<template>
  <v-container>
    <v-row justify="center">
      <v-card
        class="mx-auto"
        width="550"
        height="280"
        v-for="(item, index) in cardRegPat1Items"
        :key="index"
      >
        <v-card-text class="mt-5">
          <p class="primary--text text-subtitle-1 font-weight-medium mb-1">
            {{ item.subtitle }}
          </p>
          <v-divider inset class="mx-0" width="900"></v-divider>
          <div class="text--primary">
            <br />
            {{ item.text }}
            <br />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-row justify="center">
            <v-col cols="5">
              <v-form-base :schema="schemaFormReg1" :model="modelReg1" @input="handleEvents" />
            </v-col>
            <v-col cols="4">
              <v-btn color="secundary3" large class="text-capitalize" @click="dialogVerif = true">
                {{ item.regBtn }}
              </v-btn>
              <v-dialog
                v-model="dialogVerif"
                max-width="500"
                v-for="(item, index) in dialogAddPatientPin"
                :key="index"
              >
                <v-card style="height: 280px">
                  <v-card-title class="d-flex justify-center text-h6 pt-7">{{
                    item.title
                  }}</v-card-title>
                  <v-card-text class="d-flex justify-center mt-5">{{ item.text }}</v-card-text>
                  <v-card-actions>
                    <v-row>
                      <v-col cols="12">
                        <template>
                          <div>
                            <div class="ma-auto position-relative" style="max-width: 200px">
                              <v-otp-input
                                v-model="otp"
                                length="4"
                                :disabled="loading"
                                @finish="onFinish"
                              ></v-otp-input>
                              <v-overlay absolute :value="loading">
                                <v-progress-circular
                                  indeterminate
                                  color="primary"
                                ></v-progress-circular>
                              </v-overlay>
                            </div>
                            <span class="d-flex justify-center text-caption mt-7">
                              {{ text }}
                            </span>
                          </div>
                        </template>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
            <p class="text-caption mx-5 justify-center">
              {{ item.text2 }}
            </p>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-row>
    <v-snack-bar :snackbar="snackbar" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VFormBase from 'vuetify-form-base';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  components: {
    VFormBase,
    VSnackBar,
  },
  name: 'VCardProPatientAReg1',
  props: ['cardRegPat1Items', 'schemaFormReg1', 'modelReg1', 'handleEvents', 'dialogAddPatientPin'],
  data() {
    return {
      dialogVerif: false,
      loading: false,
      otp: '',
      text: '',
    };
  },
  computed: {
    ...mapGetters('proPatientsAPage', ['schema']),
    ...mapGetters('proPatientsAPage', ['status']),
    ...mapGetters('proPatientsAPage', ['message']),
    ...mapGetters('usersCodeVerif', ['usersPin']),
    ...mapGetters('notifications', ['snackbar']),
  },
  methods: {
    ...mapActions('proPatientsAPage', ['loadSchema']),
    ...mapActions('proPatientsAPage', ['save1']),
    ...mapActions('usersCodeVerif', ['getUsersPin']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async onFinish() {
      this.loading = true;
      const type = 'Pro';
      let model = this.modelReg1;
      model.otp = this.otp;
      model.type = type;

      await this.$store.dispatch('usersCodeVerif/getUsersPin', { model });
      const usersPin = this.usersPin;

      if (usersPin === true) {
        setTimeout(() => {
          this.loading = false;
          this.text = 'PIN de Usuario es correcto';
        }, 1500);
        setTimeout(() => {
          this.snackbar.visible = false;
          this.$store.dispatch('proPatientsAPage/save1', { model }).then(
            () => {
              this.dialogVerif = false;
              if (this.status === "success") {
                this.snackbar.visible = false;
                this.snackbar.visible = true;
                this.snackbar.content = 'El paciente ha sido notificado. Se espera la confirmación.';
              } else {
                this.snackbar.visible = false;
                this.snackbar.visible = true;
                this.snackbar.content = this.message;
              }
              this.otp = '';
              this.text = null;
            },
            () => {
              this.snackbar.visible = false;
              this.snackbar.visible = true;
              this.snackbar.content = this.message;
              this.otp = '';
              this.text = ' ';
            }
          );
          this.otp = '';
          this.text = ' ';
        }, 3000);
      } else if (usersPin === false) {
        setTimeout(() => {
          this.loading = false;
          this.text = 'PIN de Usuario es incorrecto';
        }, 1500);
      }
      this.otp = '';
      this.text = ' ';
    },
  },
};
</script>
